import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wallet05 = function Wallet05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 10H5m14 0 1.8642 3.1069c.4178.6963.6267 1.0445.7351 1.4193a3 3 0 0 1 .1124 1.0233c-.0246.3894-.153.7745-.4098 1.5449l-.2078.6235c-.3934 1.1802-.5902 1.7703-.955 2.2066a3 3 0 0 1-1.2033.8673C18.4065 21 17.7845 21 16.5404 21H7.4597c-1.2441 0-1.8661 0-2.3954-.2082a3 3 0 0 1-1.2033-.8673c-.3649-.4363-.5616-1.0264-.955-2.2066l-.2078-.6235c-.2568-.7704-.3852-1.1555-.4098-1.5449a3 3 0 0 1 .1123-1.0234c.1085-.3747.3174-.7229.7352-1.4192L5 10m14 0 .4173-1.4604c.1978-.6924.2967-1.0386.219-1.3125a1 1 0 0 0-.4353-.5771c-.242-.15-.602-.15-1.3221-.15H6.1212c-.7201 0-1.0801 0-1.3222.15a1 1 0 0 0-.4353.577c-.0777.274.0212.6202.219 1.3125L5 10m7-3.5H8.4643c-.521 0-1.0206-.2107-1.389-.5858C6.707 5.5392 6.5 5.0304 6.5 4.5s.207-1.0391.5754-1.4142c.3683-.375.868-.5858 1.389-.5858C11.2142 2.5 12 6.5 12 6.5m0 0h3.5357c.521 0 1.0206-.2107 1.389-.5858S17.5 5.0304 17.5 4.5s-.2069-1.0391-.5753-1.4142-.868-.5858-1.389-.5858c-2.75 0-3.5357 4-3.5357 4"
    })
  }));
};
export default Wallet05;